import { QRCodeSVG } from "qrcode.react";

export default function TotpQr({ uri, secret }) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-xl bg-white p-4" data-testid="totp-qr">
      <QRCodeSVG value={uri} size={176} level="M" />
      <p className="text-center text-xs text-[var(--muted-ink)]">Inquadra il codice con l'app oppure inserisci la chiave manualmente:</p>
      <code className="break-all text-xs" data-testid="totp-secret">{secret}</code>
    </div>
  );
}
